import { Service } from '../service.js';
import { env } from '../env.js';

class ConfiguracaoPendenteService extends Service {
    constructor() {
        super()
        this.url = env.url + 'configuracao-pendente'
    }

    async getConfiguracaoPendente() {
        return await this.get(this.url)
    }

    async configurar(objetoDeConfiguracao) {
        return await this.post(this.url + "/configurar", objetoDeConfiguracao)
    }
}

export const configuracaoPendenteService = new ConfiguracaoPendenteService()